// CreateQuizModal.js
import React, { useState, useEffect } from "react";
import { Modal } from '../../util/ui';
import '../../util/Quiz.css'; // Import the CSS file
import quizService from "../../services/quiz.service";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faFileUpload } from '@fortawesome/free-solid-svg-icons';
import CreateQuestionModal from "../question/question.create.component";
import EditQuestionModal from "../question/question.edit.component";
import Select from 'react-select'

const CreateQuizModal = ({ isOpen, setIsOpen, onCreateQuiz }) => {
    const [quizTitle, setQuizTitle] = useState("");
    const [quizCourse, setQuizCourse] = useState("");
    const [quizDueDate, setQuizDueDate] = useState("");
    const [quizNumQuestions, setQuizNumQuestions] = useState(0);
    const [isPublic, setIsPublic] = useState(false);
    const [showQuestionCreateModal, setShowQuestionCreateModal] = useState(false);
    const [showQuestionEditModal, setShowQuestionEditModal] = useState(false);
    const [quizQuestions, setQuizQuestions] = useState("");
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [jsonUploadError, setJsonUploadError] = useState("");
    const [jsonUploadSuccess, setJsonUploadSuccess] = useState(false);

    const topic_options = [
        { value: 'query', label: 'Query' },
        { value: 'data_cln', label: 'Data Cleaning' },
        { value: 'data_pro', label: 'Data Preprocessing' },
        { value: 'data_viz', label: 'Data Visualization' },
        { value: 'feat_eng', label: 'Feature Engineering' },
        { value: 'feat_sel', label: 'Feature Selection' },
        { value: 'analysis', label: 'Analysis' }
    ]

    useEffect(() => {
        // Reset form fields when modal is opened/closed
        if (!isOpen) {
            setQuizTitle("");
            setQuizCourse("");
            setQuizDueDate("");
            setQuizNumQuestions(0);
            setJsonUploadError("");
            setJsonUploadSuccess(false);
        }
    }, [isOpen]);

    const handleSubmit = (e) => {
        e.preventDefault();

        const author = JSON.parse(localStorage.getItem("user")).username;
        // Create quiz object
        const newQuiz = {
            title: quizTitle.trim(),
            course: quizCourse.trim(),
            due_date: quizDueDate.trim(),
            author: author,
            num_questions: quizNumQuestions,
            questions: quizQuestions,
            public: isPublic,
        };
        // Call the callback function to create quiz
        onCreateQuiz(newQuiz);
        // Close the modal
        setIsOpen(false);
    };

    const handleEditClick = (qn_obj) => {
        setShowQuestionEditModal(true);
        setSelectedQuestion(qn_obj);
    };

    const handleDeleteClick = (qn_obj) => {
        // Display a confirmation dialog
        const shouldDelete = window.confirm("Are you sure you want to delete this question?");
        if (shouldDelete) {
            handleDeleteQuizQuestion(qn_obj);
        } else {
            // Optionally handle cancellation
            console.log("Deletion canceled.");
        }
    };

    const handleDeleteQuizQuestion = async (questionObj) => {
        try {
            const response = await quizService.deleteQuizQuestion(questionObj);
            console.log("delete_qn_resp: ", response);
            setQuizQuestions(prevQuestions =>
                prevQuestions.filter(q => q.id !== questionObj.id)
            );
        } catch (error) {
            console.error("Error deleting question:", error);
        }
    };

    const handleCreateQuizQuestion = async (questionObj) => {
        try {
            const response = await quizService.createQuizQuestion(questionObj);
            console.log("create_qn_resp: ", response);
            response.question.id = response.question._id.$oid,
                setQuizQuestions([...quizQuestions, response.question]);
        } catch (error) {
            console.error("Error creating question:", error);
        }
    }

    const handleEditQuizQuestion = async (questionObj) => {
        try {
            const response = await quizService.editQuizQuestion(questionObj);
            console.log("edit_qn_resp: ", response.question);
            response.question.id = response.question._id.$oid,
                setQuizQuestions(prevQuestions =>
                    prevQuestions.map(q =>
                        q.id === response.question.id ? response.question : q
                    )
                );
        } catch (error) {
            console.error("Error editing question:", error);
            console.log("QuestionObjEoor: ", questionObj);
        }
    };

    const handleJsonUpload = async (event) => {
        setJsonUploadError(""); // Clear any previous errors
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (e) => {
            try {
                const jsonData = JSON.parse(e.target.result);
                // Basic validation - you might want to add more robust schema validation
                if (!jsonData.title || !jsonData.course || !jsonData.num_questions || !jsonData.questions) {
                    setJsonUploadError("Invalid JSON format: Missing quiz metadata.");
                    return;
                }
                const author = JSON.parse(localStorage.getItem("user")).username;
                const quizPayload = { ...jsonData, author: author };
                const response = await quizService.createQuizJson(quizPayload);
                console.log("JSON Upload Response:", response);
                // onCreateQuiz(response.quiz); // Assuming backend returns quiz object
                setJsonUploadSuccess(true); // Set success state to true
                setTimeout(() => { // Clear success message after 3 seconds (optional)
                    setJsonUploadSuccess(false);
                    setIsOpen(false); // Close modal after message and delay
                }, 1500);
            } catch (error) {
                console.error("JSON Upload Error:", error);
                setJsonUploadError("Error parsing JSON file or invalid JSON format.");
            }
        };
        reader.readAsText(file);
    };

    return (
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} clickBgToClose={false}>
            {/* <div className="modal-content"> */}
            <div className="modal-header">
                <h2>Create Quiz</h2>
            </div>
            <form onSubmit={handleSubmit}>
                <label>Quiz Title:</label>
                <input
                    className="quiz-create-input"
                    type="text"
                    placeholder="Title"
                    value={quizTitle}
                    onChange={(e) => setQuizTitle(e.target.value)}
                    required
                />

                <label>Topic:</label>
                <Select options={topic_options}
                    placeholder="Select Topic ..."
                    required
                    defaultValue={topic_options.find(({ value }) => value === quizCourse)}
                    onChange={(e) => setQuizCourse(e.value)} />

                {/* <br />
                    <label>Quiz Type:</label>
                    <select required>
                        <option value="" disabled selected>Select quiz type</option>
                        <option value="common">Common</option>
                        <option value="private">Private</option>
                    </select>
                    <br /> */}
                <br />
                <label>
                    <input
                        type="checkbox"
                        checked={isPublic}
                        onChange={e => setIsPublic(e.target.checked)}
                        style={{ marginRight: '8px' }}
                    />
                    Public (visible to all students)
                </label>
                <br />
                <label>Number of Questions:</label>
                <input
                    className="quiz-create-input"
                    type="number"
                    placeholder="Number of Questions"
                    value={quizNumQuestions}
                    onChange={(e) => setQuizNumQuestions(e.target.value)}
                    required
                />
                <div className="modal-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <h2 style={{ margin: 0 }}>Questions</h2>
                    <button type="button"
                        onClick={() => setShowQuestionCreateModal(true)}
                        className="btn btn-secondary">
                        Create New
                    </button>
                </div>

                {quizQuestions &&
                    quizQuestions.map((obj, i) => (
                        <div key={obj.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div>
                                <span className="quiz-page-option-prompt quiz-page-radio-input-prompt">{i + 1}. </span>
                                <span className="quiz-page-option-prompt quiz-page-radio-input-prompt">{obj.prompt}</span>
                            </div>
                            <div>
                                <button onClick={() => handleEditClick(obj)} type="button"
                                    style={{ border: 'none', background: 'none', cursor: 'pointer', color: 'blue', marginRight: '10px' }}>
                                    <FontAwesomeIcon icon={faPen} />
                                </button>
                                <button onClick={() => handleDeleteClick(obj)} type="button"
                                    style={{ border: 'none', background: 'none', cursor: 'pointer', color: 'red' }}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </button>
                            </div>
                        </div>
                    ))}

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '15px' }}>
                    <label htmlFor="json-upload" style={{ marginRight: '10px', cursor: 'pointer' }}>
                        <FontAwesomeIcon icon={faFileUpload} style={{ marginRight: '5px' }} /> Upload JSON
                    </label>
                    <input
                        type="file"
                        id="json-upload"
                        accept=".json"
                        style={{ display: 'none' }}
                        onChange={handleJsonUpload}
                    />
                    {jsonUploadError && <p style={{ color: 'red', marginLeft: '10px' }}>{jsonUploadError}</p>}
                </div>

                {jsonUploadSuccess && (
                    <p style={{ color: 'green', textAlign: 'center', marginTop: '10px' }}>
                        Quiz uploaded successfully!
                    </p>
                )}

                {/* <div className="button-container">
                        <button type="submit">Submit</button>
                    </div> */}
                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
                    <button className="btn btn-primary" type="submit">
                        Create Quiz
                    </button>
                    <button
                        onClick={() => setIsOpen(false)}
                        className="btn btn-danger"
                        type="button">
                        Cancel
                    </button>
                </div>

            </form>

            {showQuestionCreateModal && (
                <CreateQuestionModal
                    isOpen={showQuestionCreateModal}
                    setIsOpen={setShowQuestionCreateModal}
                    onCreateQuestion={handleCreateQuizQuestion}
                />
            )}

            {showQuestionEditModal && (
                <EditQuestionModal
                    isOpen={showQuestionEditModal}
                    setIsOpen={setShowQuestionEditModal}
                    onEditQuestion={handleEditQuizQuestion}
                    question_obj={selectedQuestion}
                />
            )}

            {/* </div> */}
        </Modal>
    );
};

export default CreateQuizModal;
